<template>
    <div class="login-container">
        <form class="login-form" @submit.prevent="login">
            <h1>Logga in</h1>
            <input class="username-input" type="text" placeholder="Användarnamn" v-model="username">    
            <input type="password" placeholder="Lösenord" v-model="password">    
            <button>Logga in</button>
        </form>
    </div>    
</template>

<script>
import firebase from 'firebase'
import db from '@/Firebase/init'

export default {
    name: 'login',

    data() {
        return {
            username: 'toppare@hotmail.se',
            password: ''
        }
    },

    computed: {
        user() {
            return this.$store.getters.user
        }
    },

    watch: {
        user(value) {
            if (value !== null && value !== undefined) {
                this.$router.push('/admin')
            }
        }
    },

    methods: {
        login() {
            this.$store.dispatch('logUserIn', {username: this.username, password: this.password})
        }
    }
    
}
</script>

<style>

.username-input {
    display: none;
}

    .login-container {
        height: 100vh;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .login-form {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background: #ffcf3c;
        max-width: 400px;
        width: 100%;
        padding: 30px 20px;
    }

    .login-form input {
        padding: 12px 15px;
        width: 100%;
        margin-top: 10px;
        box-sizing: border-box;
        border: none;
        border-radius: 5px;
    }

    .login-form button {
        padding: 15px;
        width: 100%;
        margin-top: 20px;
        background: #555e69;
        color: #fff;
        border: none;
        border-radius: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue